/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_63efd2f4"]'><cube-tab-bar :value="selectedLabelDefault" mpxModelEvent="input" :tabs="(tabs)" @_click="clickHandler" @mpxModel='(e)=>__invoke(e, [["__model","selectedLabelDefault", "__mpx_event__", ["value"], undefined]])' @change='(e)=>__invoke(e, [["changeHandler"]])'></cube-tab-bar></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_63efd2f4"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_63efd2f4"}
  /** script content **/
  require("./tab-bar-default.mpx.js?isComponent&outputPath=components%2Ftab-bar-default63efd2f4%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./tab-bar-default.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Ftab-bar-default63efd2f4%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_63efd2f4"],
    ctorType: "component",
    outputPath: "components/tab-bar-default63efd2f4/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-tab-bar':getComponent(require("../../../packages/mpx-cube-ui/src/components/tab-bar/index.mpx?isComponent&outputPath=components%2Findexff7d3170%2Findex")),'cube-tab':getComponent(require("../../../packages/mpx-cube-ui/src/components/tab-bar/tab.mpx?isComponent&outputPath=components%2Ftab66c6e44b%2Findex")),'cube-icon':getComponent(require("../../../packages/mpx-cube-ui/src/components/icon/index.mpx?isComponent&outputPath=components%2Findex1d853680%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>